import React from 'react'
import Card from '../../components/Card'

export default function () {
	return (
		<div className="flex flex-col text-slate-800 sm:mx-4 sm:my-6 md:mx-32 md:my-12 leading-loose">
			<Card className="flex flex-col">
				<h1 className="text-slate-800 mb-8">Política de Reembolso e Cancelamento – Positronic Tech</h1>

				<p>Esta política faz parte integrante dos Termos de Uso da Positronic Tech e aplica-se a todas as assinaturas adquiridas em nosso site. Ao efetuar a contratação, o cliente declara estar ciente e de acordo com as condições abaixo:</p>

				<p className="font-bold mt-4">1. Direito de Arrependimento (Art. 49 do Código de Defesa do Consumidor)</p>
				<p>O cliente poderá cancelar sua assinatura no prazo máximo de 7 (sete) dias corridos a contar da data da contratação, com reembolso integral do valor pago.</p>

				<p className="font-bold mt-4">2. Cancelamento após o prazo legal de 7 dias</p>
				<p>Após o período de 7 (sete) dias, previsto por lei, não haverá reembolso, total ou proporcional, do valor pago pela assinatura, ainda que o cliente não utilize integralmente o serviço ou solicite o cancelamento antes do fim do período contratado.</p>

				<p className="font-bold mt-4">3. Efeito imediato do cancelamento</p>
				<p>Ao solicitar o cancelamento da assinatura, o acesso do cliente ao serviço será encerrado imediatamente, não sendo possível utilizar os recursos, funcionalidades ou conteúdos após a efetivação do cancelamento.</p>

				<p className="font-bold mt-4">4. Forma de solicitação</p>
				<p>O cancelamento deverá ser solicitado por meio da Área do Usuário, acessível por meio do login no sistema ou pelos canais oficiais de atendimento disponibilizados pela Positronic Tech.</p>

				<p className="font-bold mt-4">5. Mudanças de plano</p>
				<p>Toda e qualquer mudança de plano resultará, internamente, em uma nova assinatura. Isto significa que a mudança para outro plano causará o cancelamento automático da assinatura atual e posterior criação de uma segunda assinatura, com o valor do plano selecionado. Por haver cancelamento do plano atual, todas as políticas de cancelamento serão aplicadas à assinatura anterior.</p>

				<p className="mt-8">Em caso de dúvidas, solicitações ou reclamações sobre esta Política ou o tratamento dos seus dados pessoais, entre em contato através do nosso e-mail:</p>

				<p className="mt-2">E-mail: <a href="mailto:suporte@positronictech.com.br">suporte@positronictech.com.br</a></p>

				<p className="mt-8 self-end">Data da última atualização: 08/08/2025</p>
			</Card>
		</div>
	)
}
